import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { getAfterSchools, getAfterSchoolInfo, getVideoAllLogs } from '../../redux/actions/adminActions';

import withStyles from '@material-ui/core/styles/withStyles';
import { Box, Typography, Divider, Button, TextField, MenuItem, IconButton } from '@material-ui/core';
import {
    DescriptionRounded,
    PersonAddRounded,
    Settings,
    VideoLibraryRounded,
    EditRounded,
    SubscriptionsRounded,
    AttachFileRounded,
} from '@material-ui/icons';
import CenterLoading from '../../components/layout/CenterLoading';
import CustomTableSortable from './table/CustomTableSortable';
import AdminAddAfterSchool from './dialog/AdminAddAfterSchool';
import AdminAfterSchoolSetting from './dialog/AdminAfterSchoolSetting';
import AdminEditAfterSchool from './dialog/AdminEditAfterSchool';
import AdminAfterSchoolVideos from './dialog/AdminAfterSchoolVideos';
import AdminAfterSchoolTeachingPlan from './dialog/AdminAfterSchoolTeachingPlan';
import AdminVideoLogs from './dialog/AdminVideoLogs';

const styles = (theme) => ({
    ...theme.userPage,
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    padding: {
        paddingRight: 3,
        paddingLeft: 3,
    },
});

const headCells = [
    { id: 'no', align: 'center', disablePadding: true, label: 'no.' }, //
    {
        id: 'certificateTitle',
        align: 'center',
        disablePadding: true,
        label: '자격증',
    },
    {
        id: 'title',
        align: 'center',
        disablePadding: true,
        label: '지역',
    },
    { id: 'name', align: 'center', disablePadding: false, label: '수강자' },
    { id: 'phone', align: 'center', disablePadding: true, label: '휴대전화' },
    { id: 'startDay', align: 'center', disablePadding: true, label: '시작일' },
    { id: 'endDay', align: 'center', disablePadding: true, label: '종료일' },
    { id: 'createDay', align: 'center', disablePadding: true, label: '생성일' },
    { id: 'progress', align: 'center', disablePadding: true, label: '수강진도' },
    { id: 'file', align: 'center', disablePadding: true, label: 'File' },
    { id: 'status', align: 'center', disablePadding: true, label: '수료여부' },
    { id: 'management', align: 'center', disablePadding: true, label: '상세' },
];
const initial = {
    afterSchoolId: '',
    title: '',
    name: '',
    userId: '',
    userLevel: 9,
    phone: '',
    startDay: '',
    endDay: '',
    memo: '',
    type: '',
    email: '',
    certificateTitle: '',
};

export const AdminCertificate = () => {
    const { adminLoading, afterSchools, afterSchoolInfo, videoTypeLogs, afterSchoolLectures } = useSelector(
        (state) => state.admin
    );
    const dispatch = useDispatch();

    const [open, setOpen] = useState(false);
    const [editOpen, setEditOpen] = useState(false);
    const [vOpen, setVOpen] = useState(false);
    const [tOpen, setTOpen] = useState(false);
    const [info, setInfo] = useState(initial);
    const [rows, setRows] = useState([]);
    const [selectedId, setSelectedId] = useState('all');
    const [infoOpen, setInfoOpen] = useState(false);
    const [logOpen, setLogOpen] = useState(false);
    const [lecInfo, setLecInfo] = useState(null);

    const handleEditOpen = (item) => {
        setEditOpen(true);
        setInfo(item);
    };
    const handleLogOpen = (id, afterSchoolId) => {
        setLogOpen(true);
        setLecInfo({ id, afterSchoolId });
    };

    useEffect(() => {
        dispatch(getAfterSchools());
        dispatch(getAfterSchoolInfo());
        dispatch(getVideoAllLogs());
    }, [dispatch]);

    useEffect(() => {
        if (afterSchools.length > 0) {
            setRows(GetRows(afterSchools, handleEditOpen, handleLogOpen, afterSchoolInfo, videoTypeLogs));
        }
    }, [afterSchoolInfo, afterSchools, videoTypeLogs]);

    const handleAddPerson = () => {
        setOpen(true);
    };

    const handleVideoMgmtDialog = () => {
        setVOpen(true);
    };

    return (
        <Box p={1} m={1}>
            <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
                style={{ width: '100%', marginBottom: 5 }}
            >
                <Typography variant="h5">지도자 자격증 관리</Typography>
                <Box display="flex" flexDirection="row" alignItems="center" gridGap={'8px'}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<VideoLibraryRounded />}
                        onClick={handleVideoMgmtDialog}
                    >
                        영상 관리
                    </Button>

                    <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        startIcon={<DescriptionRounded />}
                        onClick={() => setTOpen(true)}
                    >
                        교안 관리
                    </Button>
                    <Button
                        variant="contained"
                        color="inherit"
                        size="small"
                        startIcon={<PersonAddRounded />}
                        onClick={handleAddPerson}
                    >
                        수강자 추가
                    </Button>
                    <Button
                        variant="contained"
                        color="inherit"
                        size="small"
                        startIcon={<Settings />}
                        onClick={() => {
                            setInfoOpen(true);
                        }}
                    >
                        정보 설정
                    </Button>
                </Box>
            </Box>
            <Divider light style={{ marginTop: 5, marginBottom: 5 }} />
            {adminLoading ? (
                <CenterLoading />
            ) : (
                <>
                    <TextField
                        select //
                        label="선택"
                        variant="outlined"
                        size="small"
                        margin="dense"
                        value={selectedId}
                        onChange={(e) => {
                            setSelectedId(e.target.value);
                        }}
                        style={{ marginBottom: '5px', width: '200px' }}
                    >
                        <MenuItem value="all">전체</MenuItem>
                        {afterSchoolInfo.map((option, index) => (
                            <MenuItem key={'k+' + index} value={option.afterschoolVideoId}>
                                {option.title}
                            </MenuItem>
                        ))}
                    </TextField>
                    <CustomTableSortable
                        {...{
                            headCells,
                            rows: rows.filter((r) => (selectedId === 'all' ? true : r?.typeId === selectedId)),
                            defaultOrderBy: 'createdDay',
                            asc: 'desc',
                        }}
                    />
                </>
            )}

            {/* dialog */}
            <AdminAddAfterSchool {...{ open, setOpen, type: 'certificate', afterSchoolInfo }} />
            <AdminAfterSchoolSetting {...{ infoOpen, setInfoOpen, afterSchoolInfo }} />
            <AdminEditAfterSchool
                {...{
                    editOpen,
                    setEditOpen,
                    info,
                    setInfo,
                    type: 'certificate',
                    afterSchoolInfo,
                }}
            />
            <AdminAfterSchoolVideos
                {...{
                    open: vOpen,
                    setOpen: setVOpen,
                    type: 'certificate',
                    afterSchoolInfo,
                }}
            />
            <AdminAfterSchoolTeachingPlan {...{ tOpen, setTOpen, type: 'certificate', afterSchoolInfo }} />
            <AdminVideoLogs
                {...{
                    logOpen,
                    setLogOpen,
                    videoTypeLogs,
                    lecInfo,
                    dispatch,
                    afterSchoolLectures,
                }}
            />
        </Box>
    );
};

function GetRows(rows, handleEditOpen, handleLogOpen, afterSchoolInfo, videoTypeLogs) {
    if (rows.length === 0) {
        return [];
    }
    const lectureLen = afterSchoolInfo.map((as) => ({
        id: as.afterschoolVideoId,
        len: as?.lectures?.length || 0,
    }));
    const viewDone = videoTypeLogs.filter((vl) => vl.status === 'done');
    return rows
        .filter((r) => ['자격증'].includes(r.type))
        .map((r) => ({
            ...r,
            createDay: dayjs(r.createdAt * 1000).format('YYYY-MM-DD'),
            progress:
                viewDone.filter((vl) => vl.afterschoolId === r.afterSchoolId).length +
                '/' +
                lectureLen.find((l) => l.id === r.typeId)?.len,

            status: r.status === 'done' ? '수료' : '미수료',
            file: r?.certificationFile ? (
                <IconButton
                    size="small"
                    onClick={() => window.open(r.certificationFile, '수료증', 'width=600,height=800,resizable=yes')}
                >
                    <AttachFileRounded fontSize="small" color={r.status === 'done' ? 'secondary' : 'inherit'} />
                </IconButton>
            ) : (
                ''
            ),
            management: (
                <Box
                    key={r.afterSchoolId}
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    {dayjs().isBefore(r.startDay) ? '대기' : dayjs().add(-1, 'day').isAfter(r.endDay) ? '만료' : ''}

                    <Button
                        style={{ marginLeft: '10px' }}
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={() => handleEditOpen(r)}
                        startIcon={<EditRounded />}
                    >
                        수정
                    </Button>
                    <Button
                        style={{ marginLeft: '10px' }}
                        variant="contained"
                        size="small"
                        color="secondary"
                        onClick={() => handleLogOpen(r.typeId, r.afterSchoolId)}
                        startIcon={<SubscriptionsRounded />}
                    >
                        진도
                    </Button>
                </Box>
            ),
        }));
}

export default withStyles(styles)(AdminCertificate);
